'use strict';

export class Form {
	constructor(component_key) {
		this.id = component_key;
		this.$form = jQuery('.js-' + this.id + '_form');
		this.component = yalwa.v.components[component_key];
		this.data = {};
	}
	
	init() {
		this.add_events();
	}
	add_events() {
		this.$form.on(
			'submit',
			this.submit_handler
				.bind(
					this /* submit event */,
					this /* class context */
				)
		);
	}
	submit_handler(class_context, event) {
		event.preventDefault();
		class_context.api_call()
			.then(class_context.success_handling.bind(this, class_context))
			.catch(class_context.error_handling.bind(this, class_context));
	}
	success_handling(class_context, success) {
		yalwa.basics.toast({message: success.label, type: success.type});
		jQuery(`.js-${class_context.id}`).remove();
	}
	error_handling(class_context, error) {
		//console.log(error);
	}
	prepare_data() {
		const form_inputs = {}
		this.$form.find('input').each((index, element) => {
			const $input = jQuery(element);
			switch($input.attr('type')) {
				case 'radio':
					if(!$input.is(':checked')) {
						return;
					}
					break;
			}
			form_inputs[$input.attr('name')] = $input.val();
		})
		this.data = form_inputs;
		return form_inputs;
	}

	api_call() {
		return yalwa.basics.ajaxservice({
			type: 'POST',
			resource: 'account',
			action: this.component.type,
			data: this.prepare_data(),
			csrf: this.data.csrf
		});
	}
}
Object.keys(yalwa.v.components).map(component_key => {
	if (component_key.startsWith('form_')) {
		new Form(component_key).init();
	}
})

